import { NgModule } from "@angular/core";

// Disabilities
import { CandidateDisabilitiesComponent } from "./components/candidate-disabilities/candidate-disabilities.component";
import { NewCandidateDisabilitieComponent } from "./components/candidate-disabilities/new-candidate-disabilitie/new-candidate-disabilitie.component";
import { DocumentsUploadTypedisabilitiesComponent } from "./components/candidate-disabilities/new-candidate-disabilitie/components/documents-upload-typedisabilities/documents-upload-typedisabilities.component";
import { DisabilyUploadComponent } from "./components/disabily-upload/disabily-upload.component";
import { DisabilyCorrectComponent } from "./components/disabily-correct/disabily-correct.component";

import { LanguageModule } from "../language/language.module";
import { NgaModule } from "../../theme/nga.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { Angular2FontawesomeModule } from "angular2-fontawesome/angular2-fontawesome";
import { DndModule } from "ng2-dnd";

import {
  ButtonModule,
  SplitButtonModule,
  GrowlModule,
  MessagesModule,
  InputTextModule,
  PasswordModule,
  SlideMenuModule,
  FileUploadModule,
  DataTableModule,
  SharedModule,
  InputTextareaModule,
  DropdownModule,
  ChipsModule,
  DialogModule,
  RatingModule,
  ConfirmDialogModule,
  ConfirmationService,
  InputMaskModule,
  GMapModule,
  CheckboxModule,
  MultiSelectModule,
  AutoCompleteModule,
  SelectButtonModule,
  InputSwitchModule,
  ChartModule,
  ToggleButtonModule,
  AccordionModule,
  PanelModule,
  FieldsetModule,
  CalendarModule,
  TabViewModule,
  StepsModule,
  LightboxModule,
  TooltipModule,
  EditorModule,
  RadioButtonModule,
  ProgressBarModule,
} from "primeng/primeng";

import { SidebarModule } from "primeng/components/sidebar/sidebar";
import { ScheduleModule } from "primeng/components/schedule/schedule";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { StoreModule } from "@ngrx/store";
import { Angular2PromiseButtonModule } from "angular2-promise-buttons/dist";
import { AgmCoreModule } from "@agm/core";
import { HttpModule, Http, RequestOptions } from "@angular/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslatePoHttpLoader } from "@biesbjerg/ngx-translate-po-http-loader";
import { ApplicationPipesModuleModule } from "../application-pipes-module/application-pipes-module.module";
import { CandidateDisabilitiesAdminComponent } from "./components/candidate-disabilities-admin/candidate-disabilities-admin/candidate-disabilities-admin.component";
import { NewCandidateDisabilitiesAdminComponent } from "./components/candidate-disabilities-admin/candidate-disabilities-admin/new-candidate-disabilities-admin/new-candidate-disabilities-admin.component";
import { CustomAutocompleteModule } from "../custom-autocomplete/custom-autocomplete.module";
import { CandidateDisabilitiesAdminStatusComponent } from "./components/candidate-disabilities-admin/candidate-disabilities-admin/candidate-disabilities-admin-status/candidate-disabilities-admin-status.component";
import { HasPermissionService } from "../employee/service/has-permission/has-permission.service";
import { DisabilityRoutingModule } from "./disability-routing.module";

export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, "/assets/i18n/", ".po");
}

@NgModule({
  exports: [
    CandidateDisabilitiesComponent,
    NewCandidateDisabilitieComponent,
    DocumentsUploadTypedisabilitiesComponent,
    CandidateDisabilitiesAdminComponent,
    NewCandidateDisabilitiesAdminComponent,
    DisabilyCorrectComponent,
    DisabilyCorrectComponent,
  ],
  imports: [
    LanguageModule,
    ReactiveFormsModule,
    CustomAutocompleteModule,
    FormsModule,
    BrowserAnimationsModule,
    ButtonModule,
    SplitButtonModule,
    GrowlModule,
    MessagesModule,
    InputTextModule,
    PasswordModule,
    SlideMenuModule,
    FileUploadModule,
    DataTableModule,
    SharedModule,
    InputTextareaModule,
    DropdownModule,
    ChipsModule,
    DialogModule,
    RatingModule,
    ConfirmDialogModule,
    InputMaskModule,
    GMapModule,
    CheckboxModule,
    MultiSelectModule,
    AutoCompleteModule,
    SelectButtonModule,
    InputSwitchModule,
    ChartModule,
    ToggleButtonModule,
    AccordionModule,
    PanelModule,
    CalendarModule,
    TabViewModule,
    StepsModule,
    LightboxModule,
    TooltipModule,
    EditorModule,
    RadioButtonModule,
    FieldsetModule,
    SidebarModule,
    ScheduleModule,
    ProgressBarModule,
    Angular2PromiseButtonModule.forRoot({
      spinnerTpl: '<i class="fa fa-circle-o-notch fa-spin fa-fw btn-load"></i>',
      disableBtn: true,
      btnLoadingClass: "is-loading",
      handleCurrentBtnOnly: false,
    }),
    NgaModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http],
      },
    }),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyD041mK0SKDmCT9s6gaZ3XAq-psuHgA_Ec",
      libraries: ["places"],
    }),
    StoreModule.forRoot({}),
    InfiniteScrollModule,
    NgxChartsModule,
    Angular2FontawesomeModule,
    DndModule,
    ApplicationPipesModuleModule,
    DisabilityRoutingModule,
  ],
  providers: [HasPermissionService],
  declarations: [
    CandidateDisabilitiesComponent,
    NewCandidateDisabilitieComponent,
    DocumentsUploadTypedisabilitiesComponent,
    NewCandidateDisabilitiesAdminComponent,
    CandidateDisabilitiesAdminComponent,
    CandidateDisabilitiesAdminStatusComponent,
    DisabilyUploadComponent,
    DisabilyCorrectComponent,
  ],
})
export class DisabilityModule {}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/disability.module.ts